<template>
  <div id="deducciones-toolbar-deducciones">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Deducciones
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'ToolBarDeducciones',
  data() {
    return {};
  },
};
</script>

<style>

</style>
